module.exports = __webpack_public_path__ + "img/P150T_weapon_123.c4139b3d.png";